import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";

// Custom variables from the SCSS file that aren't in the theme
const CALENDAR_BORDER_GRAY = "#E0E0E0";
const CALENDAR_GRAY = "#F5F5F5";
const DARK_GREEN = "#1D352A";
const WHITE = "#FFFFFF";
const ORANGE = "#FF8200";

// Colors for booking status boxes
const COLOR_OPEN = "#ACB7BD";
const COLOR_BOOKED = "#cce5c6";
const COLOR_LATE_CANCELED = "#f9d5aa";
const COLOR_CANCELED = "#f9e79d";
const COLOR_NO_SHOW = "#FDC7BC";
const COLOR_NO_SHOW_ORGANIZER = "#c7e1f5";
const COLOR_NO_SHOW_ALL = "#f3cece";
const UPDATED_TOTAL = "#e6efed";

export const Container = styled.div`
  padding: 24px 0 24px 32px;
  background: white;
  font-family: "Rubik", sans-serif;
  font-size: 14px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const DisableLink = styled.div`
  pointer-events: none;
`;

export const CalendarContainer = styled.div`
  display: grid;
  grid-template-columns: 30px repeat(7, 152px);
  justify-items: center;
  width: fit-content;
  border-bottom: 1px solid ${CALENDAR_BORDER_GRAY};

  p {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: ${DARK_GREEN};
  }
`;

export const WeekRow = styled.div`
  display: grid;
  grid-template-columns: 30px repeat(7, 152px);
`;

export const Week = styled.div`
  height: 100%;
  padding-top: 5px;
  display: flex;
  justify-content: center;
  background-color: ${CALENDAR_GRAY};
  border-bottom: 1px solid ${CALENDAR_BORDER_GRAY};
  border-top: 1px solid ${CALENDAR_BORDER_GRAY};
  font-size: 12px;
  font-weight: 500;
  color: ${DARK_GREEN};

  &:first-of-type {
    border-top: none;
  }
`;

export const RenderDays = styled.div`
  display: flex;
  border-bottom: 1px solid ${CALENDAR_BORDER_GRAY};
`;

export const DayWrapper = styled.div<{ isToday?: boolean }>`
  width: 157px;
  height: 145px;
  padding-top: ${(props) => (props.isToday ? "33px" : "14px")};
  border-bottom: 1px solid ${CALENDAR_BORDER_GRAY};
  border-right: 1px solid ${CALENDAR_BORDER_GRAY};
  position: ${(props) => (props.isToday ? "relative" : "initial")};
`;

export const Title = styled.div<{ isToday?: boolean }>`
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 16px;
  font-weight: 400;
  color: rgba(29, 53, 42, 0.5);

  ${(props) =>
    props.isToday &&
    `
    background: ${ORANGE};
    width: 26px;
    height: 26px;
    color: ${WHITE};
    margin: 0 auto;
    border-radius: 50%;
    position: absolute;
    top: 11px;
    left: 0;
    right: 0;
  `}
`;

export const DayContent = styled.div`
  align-items: center;
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  a {
    text-decoration: none;
  }
`;

export const Box = styled.div<{ status?: string }>`
  min-width: 28px;
  height: 30px;
  width: ${(props) => (props.status === "TOTAL" ? "124px" : "30px")};
  height: ${(props) => (props.status === "TOTAL" ? "23px" : "30px")};
  padding: 4px;
  margin: 2px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${DARK_GREEN};
  font-weight: ${defaultTheme.FONT.WEIGHT.MEDIUM};
  font-size: ${defaultTheme.FONT.SIZE.MEDIUM};

  background-color: ${(props) => {
    switch (props.status) {
      case "OPEN":
        return COLOR_OPEN;
      case "BOOKED":
        return COLOR_BOOKED;
      case "LATE_CANCELED":
        return COLOR_LATE_CANCELED;
      case "CANCELED":
        return COLOR_CANCELED;
      case "NO_SHOW":
        return COLOR_NO_SHOW;
      case "ORGANIZER_NO_SHOW":
        return COLOR_NO_SHOW_ORGANIZER;
      case "NO_SHOW_ALL":
        return COLOR_NO_SHOW_ALL;
      case "TOTAL":
        return UPDATED_TOTAL;
      default:
        return "transparent";
    }
  }};
`;
